module.exports = __webpack_public_path__ + "img/link_sent.24fa9807.png";